import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'src/utils/axiosCatalog';

export const getTablesWithColumns = createAsyncThunk('/GetTablesWithColumns', async () => {
  const response = await axios.get(`/GetTablesWithColumns`);
  return response.data;
});

export const getAdHocQueryTemplateList = createAsyncThunk('/GetAdHocQueryTemplateList', async (employeeId) => {
  const response = await axios.get(`/GetAdHocQueryTemplateList/${employeeId}`);
  return response.data;
});

export const createOrUpdateQueryTemplate = createAsyncThunk('/CreateOrUpdateQueryTemplate', async (data) => {
  const response = await axios.post(`/CreateOrUpdateQueryTemplate`, data);
  return response.data;
});

export const deleteTemplate = createAsyncThunk('/DeleteTemplate', async (data) => {
  const response = await axios.post(`/DeleteTemplate`, data);
  return response.data;
});

export const updateColumnsWithQueries = createAsyncThunk('/UpdateColumnsWithQueries', async (data) => {
  const response = await axios.post(`/UpdateColumnsWithQueries`, data);
  return response.data;
});

export const executeQuery = createAsyncThunk('ExecuteQuery', async (data) => {
  const response = await axios.post(`ExecuteQuery`, data);
  return response.data;
});

export const executeQueryNew = createAsyncThunk('ExecuteQueryNew', async (data) => {
  const response = await axios.post(`ExecuteQueryNew`, data);
  return response.data;
});

export const getQueryTypes = createAsyncThunk(
  '/getQueryTypes',
  async (tableId) => {
    const response = await axios.get('/GetQueryTypes/' + tableId);
    return response.data;
  }
);

export const getTableList = createAsyncThunk(
  '/getTableList',
  async (tableId) => {
    const response = await axios.get('/GetTableList/');
    return response.data;
  }
);

export const getAllColumnsFromTables = createAsyncThunk('/GetAllColumnsFromTables', async () => {
  const response = await axios.get(`/GetAllColumnsFromTables`);
  return response.data;
});

const adhocquerySlice = createSlice({
  name: 'adhocquery',
  initialState: {
    adhocqueryList: [],
    templateList: [],
    response: null,
    deleteResponse: null,
    columnsWithQueries: [],
    queryResult: [],
    queryTypes : [],
    tableList : [],
    allColumnsList : []
  },
  reducers: {
    changeSelectedAppTranslationId(state, action) {
      state.SelectedAppTranslationId = action.payload;
    },
    resetDescriptions(state) {
      state.paymentTypeDescriptions = [];
    },
  },
  extraReducers: {
    [getTableList.pending]: (state) => {
      state.loading = true;
    },
    [getTableList.rejected]: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
    [getTableList.fulfilled]: (state, action) => {
      state.tableList = action.payload;
      state.loading = false;
    },
    [getQueryTypes.pending]: (state) => {
      state.loading = true;
    },
    [getQueryTypes.rejected]: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
    [getQueryTypes.fulfilled]: (state, action) => {
      state.queryTypes = action.payload;
      state.loading = false;
    },
    [getTablesWithColumns.pending]: (state) => {
      state.loading = 'Loading';
    },
    [getTablesWithColumns.rejected]: (state, action) => {
      state.error = action.payload;
    },
    [getTablesWithColumns.fulfilled]: (state, action) => {
      state.adhocqueryList = action.payload;
      state.loading = 'Finished';
    },
    [getAdHocQueryTemplateList.pending]: (state) => {
      state.loading = 'Loading';
    },
    [getAdHocQueryTemplateList.rejected]: (state, action) => {
      state.error = action.payload;
    },
    [getAdHocQueryTemplateList.fulfilled]: (state, action) => {
      state.templateList = action.payload;
      state.loading = 'Finished';
    },
    [createOrUpdateQueryTemplate.pending]: (state) => {
      state.loading = 'Loading';
    },
    [createOrUpdateQueryTemplate.rejected]: (state, action) => {
      state.error = action.payload;
    },
    [createOrUpdateQueryTemplate.fulfilled]: (state, action) => {
      state.response = action.payload;
      state.loading = 'Finished';
    },
    [deleteTemplate.pending]: (state) => {
      state.loading = 'Loading';
    },
    [deleteTemplate.rejected]: (state, action) => {
      state.error = action.payload;
    },
    [deleteTemplate.fulfilled]: (state, action) => {
      state.deleteResponse = action.payload;
      state.loading = 'Finished';
    },
    [updateColumnsWithQueries.pending]: (state) => {
      state.loading = 'Loading';
    },
    [updateColumnsWithQueries.rejected]: (state, action) => {
      state.error = action.payload;
    },
    [updateColumnsWithQueries.fulfilled]: (state, action) => {
      state.columnsWithQueries = action.payload;
      state.loading = 'Finished';
    },
    [executeQuery.pending]: (state) => {
      state.loading = 'Loading';
    },
    [executeQuery.rejected]: (state, action) => {
      state.error = action.payload;
    },
    [executeQuery.fulfilled]: (state, action) => {
      state.queryResult = action.payload;
      state.loading = 'Finished';
    },
    [executeQueryNew.pending]: (state) => {
      state.loading = 'Loading';
    },
    [executeQueryNew.rejected]: (state, action) => {
      state.error = action.payload;
    },
    [executeQueryNew.fulfilled]: (state, action) => {
      state.queryResult = action.payload;
      state.loading = 'Finished';
    },
    [getAllColumnsFromTables.pending]: (state) => {
      state.loading = 'Loading';
    },
    [getAllColumnsFromTables.rejected]: (state, action) => {
      state.error = action.payload;
    },
    [getAllColumnsFromTables.fulfilled]: (state, action) => {
      state.allColumnsList = action.payload;
      state.loading = 'Finished';
    }
  }
});
export const adhocqueryAction = adhocquerySlice.actions;
export default adhocquerySlice;